import { render, staticRenderFns } from "./AirplaneSeatCrossedIcon.vue?vue&type=template&id=748b6304"
import script from "./AirplaneSeatCrossedIcon.vue?vue&type=script&lang=js"
export * from "./AirplaneSeatCrossedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports